import React from 'react';
import { motion } from 'framer-motion';
export function Storytelling() {
  return <section className="w-full py-16 px-4 bg-cream" data-id="element-158">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-stretch" data-id="element-159">
        {/* Lado del Video */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative w-full h-[400px] md:h-auto md:min-h-[500px] rounded-3xl overflow-hidden shadow-2xl shadow-pink/30" data-id="element-160">
          <video src="https://cdn.magicpatterns.com/uploads/kVf3edMg1HMDmuW2u9JhfT/¡Bienvenida a tu lugar favorito! 💫- Para nosotras es un placer recibirlas, que se sientan mimad.mp4" autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover" data-id="element-161" />
        </motion.div>

        {/* Lado del Texto */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="flex flex-col justify-center space-y-6 text-center md:text-left" data-id="element-162">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-gold" data-id="element-163">
            El Corazón de VR Beauty Studio
          </h2>
          <p className="text-lg md:text-xl text-charcoal/80 leading-relaxed" data-id="element-164">
            Construir este centro fue un camino de dedicación y sueños. Cada
            detalle de nuestro estudio en Pocitos fue pensado para ofrecerte una
            experiencia de lujo y bienestar. Te invitamos a ver en este video el
            proceso de creación del espacio donde hoy cuidamos de ti.
          </p>
          <div className="pt-4 flex justify-center md:justify-start" data-id="element-165">
            <div className="w-16 h-0.5 bg-gold" data-id="element-166" />
          </div>
        </motion.div>
      </div>
    </section>;
}